import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, MapPin, Phone } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="footer-professional py-16">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-12">
          <div>
            <img 
              src="https://shortstayx.com/wp-content/uploads/2025/12/Untitled-3-e1765881709572.webp" 
              alt="ShortStayX Logo" 
              className="h-14 w-auto mb-6"
            />
            <p className="text-gray-300 leading-relaxed">
              Serviced accommodation for contractors and project teams across the North West. Premium properties designed for working professionals.
            </p>
          </div>
          
          <div>
            <h3 className="text-xl font-bold mb-6" style={{ color: '#d4a574' }}>Get In Touch</h3>
            <div className="space-y-4">
              <div className="flex items-start space-x-3 text-gray-300">
                <MapPin size={20} className="mt-1 flex-shrink-0" style={{ color: '#d4a574' }} />
                <span>955 New Chester Road, Wirral</span>
              </div>
              <div className="flex items-center space-x-3 text-gray-300">
                <Mail size={20} style={{ color: '#d4a574' }} />
                <a href="mailto:info@shortstayx.com" className="hover:text-white transition" style={{ color: '#d4a574' }}>
                  info@shortstayx.com
                </a>
              </div>
              <p className="text-gray-400 text-sm">Hours: Mon-Fri, Business hours</p>
            </div>
          </div>
          
          <div>
            <h3 className="text-xl font-bold mb-6" style={{ color: '#d4a574' }}>Our Services</h3>
            <ul className="space-y-3 text-gray-300">
              <li className="flex items-center space-x-2">
                <span className="w-2 h-2 rounded-full" style={{ background: '#d4a574' }}></span>
                <span>Serviced Accommodation</span>
              </li>
              <li className="flex items-center space-x-2">
                <span className="w-2 h-2 rounded-full" style={{ background: '#d4a574' }}></span>
                <span>Short & Medium-Term Stays</span>
              </li>
              <li className="flex items-center space-x-2">
                <span className="w-2 h-2 rounded-full" style={{ background: '#d4a574' }}></span>
                <span>Corporate & Contractor Housing</span>
              </li>
              <li className="flex items-center space-x-2">
                <span className="w-2 h-2 rounded-full" style={{ background: '#d4a574' }}></span>
                <span>Project Team Accommodation</span>
              </li>
            </ul>
          </div>
        </div>
        
        <div className="border-t pt-8 text-center text-gray-400" style={{ borderColor: 'rgba(255,255,255,0.1)' }}>
          <p>© 2026 ShortStayX. All Rights Reserved. Premium Serviced Accommodation in the North West.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;